export enum SoLifeCycleCategoryEnum{
    Production='Production',
    PRE_PRODUCTION='Pre Production',
    POST_PRODUCTION='Post Production'
}